var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
    { // 0%
      translateX: 0,
      translateY: 0,
      rotate: 0,
      scale: 1,
      opacity: 1,
      duration: 0
    },
    {
      translateX: 0,
      translateY: -_vm.windowHeight -300,
      rotate: 0,
      scale: 1,
      opacity: 1,
      duration: 500
    }
  ],"triggerAt":_vm.fifthStepTriggerAtPoint + 1900,"deltaYcounter":_vm.deltaYcounter}},[_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
      { // 0%
        translateX: _vm.windowWidth,
        translateY: _vm.windowHeight * 0.5 - (_vm.windowHeight * 0.4 / 2),
        rotate: 0,
        scale: 1,
        opacity: 1,
        duration: 0
      },
      {
        translateX: - (21 * _vm.windowHeight * 0.4),
        translateY: _vm.windowHeight * 0.5 - (_vm.windowHeight * 0.4 / 2),
        rotate: 0,
        scale: 1,
        opacity: 1,
        duration: 500
      }
    ],"triggerAt":_vm.firstStepTriggerAtPoint,"deltaYcounter":_vm.deltaYcounter}},[_c('img',{style:({'height': _vm.windowHeight * 0.3 + 'px'}),attrs:{"src":_vm.firstStep[0],"alt":"train"}})]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
      { // 0%
        translateX: _vm.windowWidth + 200,
        translateY: 0,
        rotate: 0,
        scale: 1,
        opacity: 1,
        duration: 0
      },
      {
        translateX: -200,
        translateY: 0,
        rotate: 0,
        scale: 1,
        opacity: 1,
        duration: 200
      }
    ],"triggerAt":_vm.firstStepTriggerAtPoint + 300,"deltaYcounter":_vm.deltaYcounter}},[_c('div',{staticClass:"bg-grey h-screen",style:({ width: (_vm.windowWidth + 400) + 'px', transform: 'skewX(-10deg)'})})]),_c('animate-x',{staticClass:"absolute",staticStyle:{"width":"100%"},attrs:{"keyframes":[
      { // 0%
        translateX: 0,
        translateY: 0,
        rotate: 0,
        scale: 1,
        opacity: 1,
        duration: 0
      },
      {
        translateX: -_vm.windowWidth,
        translateY: 0,
        rotate: 0,
        scale: 1,
        opacity: 1,
        duration: 500
      }
    ],"triggerAt":_vm.secondStepTriggerAtPoint + 1000,"deltaYcounter":_vm.deltaYcounter}},[_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
        { // 0%
          translateX: _vm.windowWidth * .15,
          translateY: -_vm.windowHeight,
          rotate: 0,
          scale: 1,
          opacity: 1,
          duration: 0
        },
        {
          translateX: _vm.windowWidth * .15,
          translateY: 0,
          rotate: 0,
          scale: 1,
          opacity: 1,
          duration: 500
        }
      ],"triggerAt":_vm.secondStepTriggerAtPoint,"deltaYcounter":_vm.deltaYcounter}},[_c('img',{style:({'height': _vm.windowHeight * .3 + 'px'}),attrs:{"src":_vm.secondStep[0],"alt":"white drops"}})]),_c('animate-x',{staticClass:"absolute",staticStyle:{"transform-origin":"top left"},attrs:{"keyframes":[
        { // 0%
          translateX: _vm.windowWidth * .15,
          translateY: _vm.windowHeight * .3,
          rotate: 0,
          scale: 1 * _vm.scaleFactorTxt,
          opacity: 0,
          duration: 0
        },
        {
          translateX: _vm.windowWidth * .15,
          translateY: _vm.windowHeight * .3,
          rotate: 0,
          scale: 1 * _vm.scaleFactorTxt,
          opacity: 1,
          duration: 500
        }
      ],"triggerAt":_vm.secondStepTriggerAtPoint + 300,"deltaYcounter":_vm.deltaYcounter}},[_c('div',{staticStyle:{"max-width":"320px"}},[_c('h2',{staticClass:"text-orange mb-2",staticStyle:{"font-size":"60px"}},[_vm._v("Monitoring")]),_c('p',{staticClass:"mb-5",staticStyle:{"font-size":"24px"}},[_vm._v("We use plain line pattern technology (PLPR) to inspect track for faults.")]),_c('p',{staticStyle:{"font-size":"24px"}},[_vm._v("The New Measurement Train (or Flying Banana as it's affectionately known) takes thousands of pictures of the track as it travels.")])])]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
        { // 0%
          translateX: _vm.windowWidth * .45,
          translateY: _vm.windowHeight * 0.1,
          rotate: 0,
          scale: 0,
          opacity: 1,
          duration: 0
        },
        {
          translateX: _vm.windowWidth * .45,
          translateY: _vm.windowHeight * 0.1,
          rotate: 0,
          scale: 1,
          opacity: 1,
          duration: 500
        }
      ],"triggerAt":_vm.secondStepTriggerAtPoint + 500,"deltaYcounter":_vm.deltaYcounter}},[_c('img',{style:({'height': _vm.windowHeight * .7 + 'px'}),attrs:{"src":_vm.secondStep[1],"alt":"camera attached to belly of the train"}})])],1),_c('animate-x',{staticClass:"absolute w-screen",attrs:{"keyframes":[
      { // 0%
        translateX: 0,
        translateY: 0,
        rotate: 0,
        scale: 1,
        opacity: 1,
        duration: 0
      },
      {
        translateX: -_vm.windowWidth -100,
        translateY: 0,
        rotate: 0,
        scale: 1,
        opacity: 1,
        duration: 500
      }
    ],"triggerAt":_vm.thirdStepTriggerAtPoint + 1200,"deltaYcounter":_vm.deltaYcounter}},[_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
        { // 0%
          translateX: _vm.windowWidth,
          translateY: 0,
          rotate: 0,
          scale: 1,
          opacity: 0,
          duration: 0
        },
        {
          translateX: _vm.windowWidth * .1,
          translateY: 0,
          rotate: 0,
          scale: 1,
          opacity: 1,
          duration: 500
        }
      ],"triggerAt":_vm.thirdStepTriggerAtPoint,"deltaYcounter":_vm.deltaYcounter}},[_c('img',{style:({'height': _vm.windowHeight * 0.3 + 'px'}),attrs:{"src":_vm.thirdStep[0],"alt":"green dots"}})]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
        { // 0%
          translateX: _vm.windowWidth,
          translateY: _vm.windowHeight - (_vm.windowHeight * 0.3),
          rotate: 0,
          scale: 1,
          opacity: 1,
          duration: 0
        },
        {
          translateX: 0,
          translateY: _vm.windowHeight - (_vm.windowHeight * 0.3),
          rotate: 0,
          scale: 1,
          opacity: 1,
          duration: 500
        }
      ],"triggerAt":_vm.thirdStepTriggerAtPoint + 100,"deltaYcounter":_vm.deltaYcounter}},[_c('img',{style:({'height': _vm.windowHeight * 0.3 + 'px'}),attrs:{"src":_vm.thirdStep[1],"alt":"zig zag"}})]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
        { // 0%
          translateX: _vm.windowWidth * .15,
          translateY: _vm.windowHeight * .4,
          rotate: 0,
          scale: 0,
          opacity: 1,
          duration: 0
        },
        {
          translateX: _vm.windowWidth * .15,
          translateY: _vm.windowHeight * .4,
          rotate: 0,
          scale: 1,
          opacity: 1,
          duration: 500
        }
      ],"triggerAt":_vm.thirdStepTriggerAtPoint + 200,"deltaYcounter":_vm.deltaYcounter}},[_c('img',{style:({'height': _vm.windowHeight * 0.12 + 'px'}),attrs:{"src":_vm.thirdStep[2],"alt":"birds"}})]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
        { // 0%
          translateX: _vm.windowWidth,
          translateY: _vm.windowHeight * .7,
          rotate: 0,
          scale: 1,
          opacity: 0,
          duration: 0
        },
        {
          translateX: _vm.windowWidth * .20,
          translateY: _vm.windowHeight * .7,
          rotate: 0,
          scale: 1,
          opacity: 1,
          duration: 500
        }
      ],"triggerAt":_vm.thirdStepTriggerAtPoint + 300,"deltaYcounter":_vm.deltaYcounter}},[_c('img',{style:({'height': _vm.windowHeight * 0.3 + 'px'}),attrs:{"src":_vm.thirdStep[3],"alt":"black arrows"}})]),_c('animate-x',{staticClass:"absolute z-10",attrs:{"keyframes":[
        { // 0%
          translateX: _vm.windowWidth,
          translateY: _vm.windowHeight * .1,
          rotate: 0,
          scale: 1,
          opacity: 0,
          duration: 0
        },
        {
          translateX: _vm.windowWidth * .35,
          translateY: _vm.windowHeight * .1,
          rotate: 0,
          scale: 1,
          opacity: 1,
          duration: 500
        }
      ],"triggerAt":_vm.thirdStepTriggerAtPoint + 400,"deltaYcounter":_vm.deltaYcounter}},[_c('img',{style:({'height': _vm.windowHeight * 0.85 + 'px'}),attrs:{"src":_vm.thirdStep[4],"alt":"woman pointing at a clipboad"}})]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
        { // 0%
          translateX: _vm.windowWidth,
          translateY: _vm.windowHeight * .1,
          rotate: 0,
          scale: 1,
          opacity: 1,
          duration: 0
        },
        {
          translateX: _vm.windowWidth * .6,
          translateY: _vm.windowHeight * .1,
          rotate: 0,
          scale: 1,
          opacity: 1,
          duration: 500
        }
      ],"triggerAt":_vm.thirdStepTriggerAtPoint + 500,"deltaYcounter":_vm.deltaYcounter}},[_c('img',{style:({'height': _vm.windowHeight * 0.8 + 'px'}),attrs:{"src":_vm.thirdStep[5],"alt":"clipboard"}}),_c('div',{staticClass:"sr-only"},[_c('h2',[_vm._v("FACTS")]),_c('p',[_vm._v("Track workers on foot can check 210 miles of track for faults in a week.")]),_c('p',[_vm._v("The train covers 2,000 miles in the same time!")]),_c('p',[_vm._v("Safer - no workers trackside")]),_c('p',[_vm._v("Will save £23m up to 2024.")])])])],1),_c('animate-x',{staticClass:"absolute w-screen h-screen",attrs:{"keyframes":[
      { // 0%
        translateX: 0,
        translateY: 0,
        rotate: 0,
        scale: 1,
        opacity: 1,
        duration: 0
      },
      {
        translateX: 0,
        translateY: -_vm.windowHeight,
        rotate: 0,
        scale: 1,
        opacity: 1,
        duration: 500
      }
    ],"triggerAt":_vm.fourthStepTriggerAtPoint + 700,"deltaYcounter":_vm.deltaYcounter}},[_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
        { // 0%
          translateX: _vm.windowWidth,
          translateY: 0,
          rotate: 0,
          scale: 1,
          opacity: 0,
          duration: 0
        },
        {
          translateX: 0,
          translateY: 0,
          rotate: 0,
          scale: 1,
          opacity: 1,
          duration: 500
        }
      ],"triggerAt":_vm.fourthStepTriggerAtPoint,"deltaYcounter":_vm.deltaYcounter}},[_c('div',{staticClass:"w-screen h-screen bg-center bg-cover",style:({'background-image': ("url(" + (_vm.fourthStep[0]))})})]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
        { // 0%
          translateX: 0,
          translateY: _vm.windowHeight * .4,
          rotate: 0,
          scale: 0,
          opacity: 1,
          duration: 0
        },
        {
          translateX: 0,
          translateY: _vm.windowHeight * .4,
          rotate: 0,
          scale: 1,
          opacity: 1,
          duration: 500
        }
      ],"triggerAt":_vm.fourthStepTriggerAtPoint + 100,"deltaYcounter":_vm.deltaYcounter}},[_c('div',{staticClass:"w-screen bg-contain bg-center bg-no-repeat",style:({'background-image': ("url(" + (_vm.fourthStep[2])), 'height': _vm.windowHeight * .35 + 'px'})}),_c('div',{staticClass:"sr-only"},[_vm._v("2000 miles of track in one week")])]),_c('animate-x',{staticClass:"absolute z-10",staticStyle:{"transform-origin":"top left"},attrs:{"keyframes":[
        { // 0%
          translateX: _vm.windowWidth * .09,
          translateY: _vm.windowHeight * .1,
          rotate: 0,
          scale: _vm.scaleFactorTxt,
          opacity: 0,
          duration: 0
        },
        {
          translateX: _vm.windowWidth * .09,
          translateY: _vm.windowHeight * .1,
          rotate: 0,
          scale: _vm.scaleFactorTxt,
          opacity: 1,
          duration: 400
        }
      ],"triggerAt":_vm.fourthStepTriggerAtPoint + 100,"deltaYcounter":_vm.deltaYcounter}},[_c('p',{staticStyle:{"max-width":"600px","font-size":"30px"}},[_vm._v("The inspection team are instead on the train, reviewing crystal clear images that advanced systems generate and scan.")])]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
        { // 0%
          translateX: _vm.windowWidth * .62,
          translateY: 0,
          rotate: 0,
          scale: 1,
          opacity: 0,
          duration: 0
        },
        {
          translateX: _vm.windowWidth * .62,
          translateY: 0,
          rotate: 0,
          scale: 1,
          opacity: 1,
          duration: 500
        }
      ],"triggerAt":_vm.fourthStepTriggerAtPoint + 100,"deltaYcounter":_vm.deltaYcounter}},[_c('img',{style:({'height': _vm.windowHeight * .2 + 'px'}),attrs:{"src":_vm.fourthStep[1],"alt":"purple dots"}})])],1),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
      { // 0%
        translateX: -3000,
        translateY: 0,
        rotate: 0,
        scale: 1,
        opacity: 0,
        duration: 0
      },
      {
        translateX: 0,
        translateY: 0,
        rotate: 0,
        scale: 1,
        opacity: 1,
        duration: 1200
      }
    ],"triggerAt":_vm.fifthStepTriggerAtPoint + 100,"deltaYcounter":_vm.deltaYcounter}},[_c('div',{staticClass:"h-screen bg-center bg-cover",style:({'background-image': ("url(" + (_vm.fifthStep[0])), width: '6000px'})})]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
      { // 0%
        translateX: 0,
        translateY: 0,
        rotate: 0,
        scale: 1,
        opacity: 0,
        duration: 0
      },
      {
        translateX: 0,
        translateY: 0,
        rotate: 0,
        scale: 1,
        opacity: 1,
        duration: 300
      }
    ],"triggerAt":_vm.fifthStepTriggerAtPoint,"deltaYcounter":_vm.deltaYcounter}},[_c('div',{staticClass:"w-screen h-screen bg-center bg-cover",style:({'background-image': ("url(" + (_vm.fifthStep[1]))})})]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
      { // 0%
        translateX: _vm.windowWidth * .1,
        translateY: _vm.windowHeight * .4,
        rotate: 0,
        scale: 1,
        opacity: 0,
        duration: 0
      },
      {
        translateX: _vm.windowWidth * .1,
        translateY: _vm.windowHeight * .4,
        rotate: 0,
        scale: 1,
        opacity: 1,
        duration: 500
      }
    ],"triggerAt":_vm.fifthStepTriggerAtPoint + 1300,"deltaYcounter":_vm.deltaYcounter}},[_c('img',{style:({height: _vm.windowHeight * .5 + 'px'}),attrs:{"src":_vm.fifthStep[2],"alt":"speech bubble"}}),_c('div',{staticClass:"sr-only"},[_c('p',[_vm._v("The train travels at 125mph, photographing every 20mm.")]),_c('p',[_vm._v("Seven super high-tech cameras can identify faults, such as dips, faulty joints, loose or high stone...")]),_c('p',[_vm._v("Thermal imaging scans for loose connections in electrics that could be overheating.")])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }